import BannerCta from '@/components/general/BannerCta';
import React from 'react';
import styles from '../styles.module.css';
import ConfirmationButton from '@/components/common/ConfirmationButton';
import MainIcons from '@/icons/main';

export default function ServiceBanner({
  title = 'هیچ خلافی‌ای را از دست ندهید',
  text = 'با افزودن همهٔ پلاک‌ها و فعال‌سازی اعلان‌های کارا، از وضعیت هر خودرو به‌محض تغییر مطلع شوید.',
  service = 5,
}) {
  return (
    <BannerCta className={`${styles.bannercta}`}>
      <div className={`${styles.bannerWrapper}`}>
        <h2 className={styles.bannerTitle}>{title}</h2>
        <p className={styles.bannerSub}>{text}</p>
      </div>
      <ConfirmationButton
        className={`squareButton ${styles.buttonContainer}`}
        extraConfirmStyle={`btn-white squareButton`}
        extraRejectStyle={`squareButton`}

        confirmText={'مشاهده خلافی‌ها'}
        confirmHref={`/service/خلافی-خودرو`}
        confirmType="link"
        rejectText={
          <>
            <MainIcons.plusIcon fill="#fff" />
            {' افزودن پلاک جدید'}
          </>
        }
        rejectHref="/sub-users"
        rejectType="link"
      />
    </BannerCta>
  );
}
